import { SkeletonLoader, typographyV2 } from '@toggle/design-system';
import styled, { css } from 'styled-components';

export const SkeletonChartLoader = styled(SkeletonLoader).attrs({
  areas: [
    {
      styles: {
        width: '100%',
        height: '350px',
        borderRadius: '8px',
      },
    },
  ],
})``;

export const Title = styled.p`
  display: flex;
  justify-content: space-between;
  ${typographyV2.titleBase};
  text-underline-offset: 4px;

  & span {
    font-family: var(--font-roboto-mono);
    text-align: right;
    color: var(--text-soft);
    ${typographyV2.bodySm}
    display: inline-block;
    padding-right: 50px;
  }
`;


export const Container = styled.div<{ $isDrawer: boolean }>`
  ${({ $isDrawer }) =>
    $isDrawer &&
    css`
      border-bottom: 2px solid var(--border-soft);
    `}
`;